export const doctors = [
  {
    id: 1,
    name: 'Др. Александр Тукан',
    nameRo: 'Dr. Alexandru Tucan',
    nameEn: 'Dr. Alexandru Tucan',
    specialization: 'Главный врач, стоматолог-ортопед',
    specializationRo: 'Medic șef, stomatolog ortoped',
    specializationEn: 'Chief Doctor, Orthopedic Dentist',
    experience: 31,
    image: 'https://public.readdy.ai/ai/img_res/aaf13292-9990-427c-a33a-676007f1837b.png',
    education: 'Государственный медицинский университет им. Н. Тестемицану',
    educationRo: 'Universitatea de Stat de Medicină și Farmacie Nicolae Testemițanu',
    educationEn: 'Nicolae Testemițanu State University of Medicine and Pharmacy'
  },
  {
    id: 2,
    name: 'Др. Наталья Стародубова',
    nameRo: 'Dr. Natalia Starodubova',
    nameEn: 'Dr. Natalia Starodubova',
    specialization: 'Стоматолог-терапевт',
    specializationRo: 'Stomatolog terapeut',
    specializationEn: 'Therapeutic Dentist',
    experience: 31,
    image: 'https://static.readdy.ai/image/4f8e52dde3dda7b1227768a95bdc6f97/61cc6e6a2cf25fee789feffcc1022ab0.jpeg',
    education: 'Государственный медицинский университет им. Н. Тестемицану',
    educationRo: 'Universitatea de Stat de Medicină și Farmacie Nicolae Testemițanu',
    educationEn: 'Nicolae Testemițanu State University of Medicine and Pharmacy'
  },
  {
    id: 3,
    name: 'Др. Сергей Кетруш',
    nameRo: 'Dr. Sergei Ketrush',
    nameEn: 'Dr. Sergei Ketrush',
    specialization: 'Стоматолог-ортопед',
    specializationRo: 'Stomatolog ortoped',
    specializationEn: 'Orthopedic Dentist',
    experience: 31,
    image: 'https://static.readdy.ai/image/4f8e52dde3dda7b1227768a95bdc6f97/753b68ca07fc1fadd885f0da00deb096.jpeg',
    education: 'Государственный медицинский университет им. Н. Тестемицану',
    educationRo: 'Universitatea de Stat de Medicină și Farmacie Nicolae Testemițanu',
    educationEn: 'Nicolae Testemițanu State University of Medicine and Pharmacy'
  },
  {
    id: 4,
    name: 'Др. Лариса Жукова',
    nameRo: 'Dr. Larisa Jucova',
    nameEn: 'Dr. Larisa Zhukova',
    specialization: 'Стоматолог-терапевт',
    specializationRo: 'Stomatolog terapeut',
    specializationEn: 'Therapeutic Dentist',
    experience: 31,
    image: 'https://static.readdy.ai/image/4f8e52dde3dda7b1227768a95bdc6f97/5461bca683be4692e7e0d25da78bab03.jpeg',
    education: 'Государственный медицинский университет им. Н. Тестемицану',
    educationRo: 'Universitatea de Stat de Medicină și Farmacie Nicolae Testemițanu',
    educationEn: 'Nicolae Testemițanu State University of Medicine and Pharmacy'
  },
  {
    id: 5,
    name: 'Др. Сергей Михалаки',
    nameRo: 'Dr. Sergei Mihalachi',
    nameEn: 'Dr. Sergei Mihalachi',
    specialization: 'Стоматолог-хирург',
    specializationRo: 'Stomatolog chirurg',
    specializationEn: 'Dental Surgeon',
    experience: 29,
    image: 'https://static.readdy.ai/image/4f8e52dde3dda7b1227768a95bdc6f97/3841a67573d17ea0d0b0f6e4cbc3fd7e.jpeg',
    education: 'Государственный медицинский университет им. Н. Тестемицану',
    educationRo: 'Universitatea de Stat de Medicină și Farmacie Nicolae Testemițanu',
    educationEn: 'Nicolae Testemițanu State University of Medicine and Pharmacy'
  }
];
